/**
 * Created by huangzhangshu on 2019-07-26
 */
import React from 'react';
import Icon from '../IconX';
import './Indicator.less';

export interface IndicatorProps {
  // 关闭回调方法
  onClose?: () => void;
  // 显示文字
  tip: string;
  // 样式前缀
  prefixCls: string;
}

export default class Indicator extends React.Component<IndicatorProps> {

  static defaultProps = {
    prefixCls: 'vadp-ui-indicator',
  }

  render() {

    const { onClose, tip, prefixCls } = this.props;

    return (
      //  className="ant-spin-show-text ant-spin-text"
      <div className={`${prefixCls}`}>
        <Icon type="loading" style={{ fontSize: 24 }} />
        {tip && <span style={{ marginTop: 8 }}>{tip}</span>}
        {onClose && <a className={`${prefixCls}-close`} onClick={onClose}>
          <Icon type="-close" style={{ fontSize: 18 }} />
        </a>}
      </div>
    );
  }
}
